import config from '../../../../../config';

const initialState = {
  checklistMode: (!config.disableChecklistMode && window.localStorage.getItem('checklistMode')) || 'default',
  trades: null,
  page: 1,
  refreshData: false,
  expanded: {},
  lastFetchedTrades: Date.now(),
  filtersFormState: {
    data: {}
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_CHECKLIST_MODE': {
      window.localStorage.setItem('checklistMode', payload.checklistMode);
      return {
        ...state,
        checklistMode: payload.checklistMode,
      };
    }
    case 'ROUTE': {
      return {
        ...state,
        trades: null,
        filtersFormState: initialState.filtersFormState,
        page: 1,
      };
    }
    case 'TOGGLE_EXPANDED': {
      const { tradeId, active } = payload;
      let expanded = {
        ...state.expanded,
        [tradeId]: active,
      };
      if(!state.filtersFormState.data.allowMultiExpand){
        expanded = {
          [tradeId]: active,
        };
      }
      return {
        ...state,
        expanded,
      };
    }
    case 'REFRESH_DATA': {
      return {
        ...state,
        refreshData: true,
      };
    }
    case 'REFRESHING_DATA': {
      return {
        ...state,
        refreshData: false,
      };
    }
    case 'SET_TRADES': {
      const { trades, page, lastFetchedTrades } = payload;
      return {
        ...state,
        trades,
        page,
        lastFetchedTrades,
        refreshData: false,
      };
    }
    case 'TRADE_FILTERS_CHANGE': {
      const { filtersFormState } = payload;
      return {
        ...state,
        filtersFormState,
        page: 1,
      };
    }
    case 'TRADES_NEXT_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page + 1,
      };
    }
    case 'TRADES_PREVIOUS_PAGE': {
      const page = Number(state.page);
      return {
        ...state,
        page: page > 1 ? page - 1 : 1,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/Trades.reducer.js